import { makeAutoObservable } from "mobx"

export class AuthUi {
  surname = ""
  username = ""
  password = ""

  constructor() {
    makeAutoObservable(this)
  }

  setUsername(value: string) {
    this.username = value
  }
  setSurname(value: string) {
    this.surname = value
  }
  setPassword(value: string) {
    this.password = value
  }
}
